<!--
Copyright by:

by ESS-Ehrhardt Software Solutions & Service GmbH
Basselscheider Str. 55
D-56281 Emmelshausen
+49 (0) 67 42 / 87 27 0
info@epg.com
-->
<!-- Template handles its own layout (header, content, buttons) -->
<div *ngIf="templateHandlesLayout && template">
  <ng-container
    *ngTemplateOutlet="
      template;
      context: {
        $implicit: {
          confirmClicked: confirmClicked.bind(this),
          cancelClicked: cancelClicked.bind(this),
          confirmButtonText: confirmButtonText,
          cancelButtonText: cancelButtonText,
          header: header
        }
      }
    "
  ></ng-container>
</div>

<!-- Default layout (backward compatible) -->
<div *ngIf="!templateHandlesLayout">
  <div id="custom_dialog">
    <span class="dialog_header">{{ header }}</span>
  </div>
  <div fxLayout="column">
    <span
      *ngIf="messageTitle"
      id="dialog_message_title"
      class="dialog_message_title"
      [innerHTML]="messageTitle"
    ></span>

    <!-- Template projection support -->
    <div *ngIf="template; else stringMessage">
      <ng-container *ngTemplateOutlet="template"></ng-container>
    </div>

    <!-- Fallback to string message -->
    <ng-template #stringMessage>
      <span id="dialog_message_content" class="dialog_message_content">{{ message }}</span>
    </ng-template>
  </div>
  <div class="mat-dialog-actions">
    <button mat-raised-button id="dialog_confirmation_button" mat-button (click)="confirmClicked()">
      {{ confirmButtonText }}
    </button>
    <button
      id="dialog_cancel_button"
      mat-raised-button
      color="primary"
      (click)="cancelClicked()"
      cdkFocusInitial
    >
      {{ cancelButtonText }}
    </button>
  </div>
</div>
